interface HSGLogoProps {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
}

export default function HSGLogo({ variant = 'light', size = 'md' }: HSGLogoProps) {
  const isLight = variant === 'light';

  const monogramSize = size === 'sm' ? 'text-2xl' : size === 'lg' ? 'text-5xl' : 'text-3xl';
  const wordmarkSize = size === 'sm' ? 'text-[8px]' : size === 'lg' ? 'text-[13px]' : 'text-[10px]';
  const dividerH = size === 'sm' ? 'h-6' : size === 'lg' ? 'h-12' : 'h-8';

  return (
    <div className="flex items-center gap-3 select-none">
      {/* Monogram */}
      <span
        className={`font-['Cormorant_Garamond'] font-semibold tracking-widest leading-none ${monogramSize} ${
          isLight ? 'text-white' : 'text-[#2C2C2C]'
        }`}
      >
        HSG
      </span>

      {/* Divider */}
      <div className={`w-px ${dividerH} ${isLight ? 'bg-white/40' : 'bg-[#2C2C2C]/30'}`}></div>

      {/* Wordmark */}
      <div className="flex flex-col justify-center gap-0.5">
        <span
          className={`uppercase tracking-[0.22em] font-medium leading-none ${wordmarkSize} ${
            isLight ? 'text-white' : 'text-[#2C2C2C]'
          }`}
        >
          Higher Standard
        </span>
        <span
          className={`uppercase tracking-[0.35em] font-light leading-none ${wordmarkSize} ${
            isLight ? 'text-[#C9A96E]' : 'text-[#8B7355]'
          }`}
        >
          Global
        </span>
      </div>
    </div>
  );
}